import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  withRouter,
  useLocation,
} from 'react-router-dom'
import React, { useState } from 'react'
import 'antd/dist/antd.css'
import './App.css'
import { Layout, Select } from 'antd'

import Home from './pages/Home/index.jsx'
import ParlSearch from './pages/Database/parlSearch.jsx'
import UkParlDetail from './pages/Database/ukParlDetail.jsx'
import CAParlDetail from './pages/Database/caParlDetail.jsx'
import BaseParlDetail from './pages/Database/baseParlDetail.jsx'
import SenatorDetail from './pages/Database/senatorDetail.jsx'
import SenatorSearch from './pages/Database/senatorSearch.jsx'
import Team from './pages/Team/index.jsx'
import MenuBar from './components/MenuBar.jsx'
import Achievement from './pages/Achievement/index.jsx'
import AboutUs from './pages/AboutUs/index.jsx'
import Building from './pages/Building/index.jsx'
import News from './pages/News/index.jsx'
import NewsDetail from './pages/News/detail.jsx'
import Tool from './pages/Tool/index.jsx'
import GraphMeeting from './pages/Tool/graph/uk/index.jsx'
import worldMap from './pages/Tool/map/index.jsx'
import footerImg from './assets/img/common/footer.jpg'
import logoImg from './assets/img/common/logo.svg'
import { useMeetingStore } from './store/meeting'

const { Header, Content, Footer } = Layout
const { Option } = Select
const originalSetItem = localStorage.setItem;

localStorage.setItem = function (key, value) {
  const event = new Event("itemInserted");
  event.value = value; // Optional..
  event.key = key; // Optional..
  document.dispatchEvent(event);
  originalSetItem.apply(this, arguments);
};
const handleChange = (value) => {
  localStorage.setItem('selCountry', value)
};

const App = () => {
  const location = useLocation()
  console.log('location', location)
  document.title = '议会大数据平台'

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        style={{
          background: '#ffffff',
          position: 'fixed',
          width: '100%',
          zIndex: 100,
          boxShadow: '0px 2px rgba(0, 0, 0, 0.04)',
          padding: '0px 19% 0px 11%',
        }}
      >
        <a target="_blank" href="/">
          <img
            src={logoImg}
            style={{
              width: 164,
              float: 'left',
              marginTop: 22,
              marginRight: 10,
            }}
            alt="logo"
          />
        </a>
        {location.pathname === '/tool/graph' ? (
          <div style={{ display: 'inline-block' }}>
            <span style={{ fontSize: 27, fontWeight: 700, color: '#004aad' }}>
              关联图谱
            </span>
            <Select
              onChange={handleChange}
              style={{ width: 200, marginLeft: 10, marginRight: 10 }}
              placeholder="选择国家"
            >
              <Option value="us">美国</Option>
              <Option value="uk">英国</Option>
              <Option value="ru">俄罗斯</Option>
              <Option value="eu">欧洲</Option>
              <Option value="fr">法国</Option>
              <Option value="ge">德国</Option>
              <Option value="ca">加拿大</Option>
              <Option value="pk">巴基斯坦</Option>
              <Option value="my">马来西亚</Option>
              <Option value="sg">新加坡</Option>
              <Option value="tr">土耳其</Option>
              <Option value="nz">新西兰</Option>
              <Option value="india">印度</Option>
              <Option value="pl">波兰</Option>
              <Option value="za">南非</Option>
              <Option value="at">奥地利</Option>
            </Select>
          </div>
        ) : location.pathname === '/tool/map' ? (
          <div style={{ display: 'inline-block' }}>
            <span style={{ fontSize: 27, fontWeight: 700, color: '#004aad' }}>
              数据地图
            </span>
          </div>
        ) : (
          ''
        )}
        <MenuBar />
      </Header>

      <Content
        style={{
          minHeight: `calc(100% - 160px)`,
          marginTop: 64,
          background: '#ffffff',
        }}
      >
        <Switch>
          <Route exact path="/">
            <Redirect to="/index" />
          </Route>
          <Route path="/index" component={Home} />
          <Route exact path="/news" component={News} />
          <Route exact path="/news/:id" component={NewsDetail} />
          <Route exact path="/tool" component={Tool} />
          <Route exact path="/tool/graph" component={GraphMeeting} />
          <Route exact path="/tool/map" component={worldMap} />
          <Route exact path="/database/parl/:country" component={ParlSearch} />
          <Route
            exact
            path="/database/parl/uk/detail/:id"
            component={UkParlDetail}
          />
          {/* <Route
            exact
            path="/database/parl/canada/detail/:id"
            component={CAParlDetail}
          /> */}
          <Route
            exact
            path="/database/parl/:country/detail/:id"
            component={BaseParlDetail}
          />
          <Route
            exact
            path="/database/senator/:country"
            component={SenatorSearch}
          />
          <Route
            exact
            path="/database/senator/:country/detail/:id"
            component={SenatorDetail}
          />
          <Route path="/team" component={Team} />
          <Route path="/achievement" component={Achievement} />
          <Route path="/aboutus" component={AboutUs} />
          <Route path="/building" component={Building} />
        </Switch>
      </Content>

      <Footer
        style={{ backgroundImage: `url(${footerImg})`, padding: '10px 0' }}
      >
        <div className="footer-text">
          邮箱：parliament_whu@163.com{' '}
          <span style={{ marginLeft: 30 }}>
            {' '}
            地址：湖北省武汉市武昌区珞珈山武汉大学信息管理学院
          </span>
        </div>
        <div className="footer-text">
          ©Copyright 2021
          武汉大学信息检索与知识挖掘研究所；武汉大学信息资源研究中心；武汉大学大数据研究院
        </div>
      </Footer>
    </Layout>
  )
  // }
}

export default withRouter(App)
